module.exports = __webpack_public_path__ + "static/media/annotation.652eade3.svg";